<template>
  <validation-form @on-submit="updateAccount">
    <div id="student-information isis-page">
      <div
        class="fixed-plugin change-pwd"
        v-if="hasValidRole(role, [Role.Admin, Role.Principal])"
      >
        <button-change-password
          @showChangePasswordModal="showChangePasswordModal()"
        >
        </button-change-password>
      </div>
      <change-password
        :name="changePasswordModal.name"
        :title="changePasswordModal.title"
        :uuid="uuid"
      ></change-password>

      <isis-fab
        title="Student's note"
        v-if="hasValidRole(this.role, [Role.Admin, Role.Principal])"
      >
        <template #dropdown-menu-content>
          <fixed-note-list
            :list="studentData.notes"
            :update-note-func="updateStudentData"
          ></fixed-note-list>
        </template>
      </isis-fab>

      <div class="isis-page__header md-layout">
        <div class="md-layout-item">
          <div class="nav-link" @click="goToStudentPage">
            <i class="fas fa-chevron-left"></i>
            <span>{{ $t("student.account_detail") }}</span>
          </div>
        </div>
      </div>
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card class="w-3/5">
            <md-card-content class="p-4">
              <p class="font-medium text-lg">{{ studentData.full_name }}</p>
              <p class="font-normal text-base">
                {{ studentData.student_code }}
              </p>
            </md-card-content>
          </md-card>
          <!--          <div v-if="!isModeSupporter" class="hidden lg:block">
                      <md-card class="rounded-2xl w-[45px] h-[45px]">
                        <md-button
                          class="md-button md-just-icon md-simple"
                          @click="connectChat"
                        >
                          <md-icon>chat</md-icon>
                        </md-button>
                      </md-card>
                    </div>-->
        </div>
        <div class="md-layout-item">
          <Avatar
            :defaultUrl="avatarUrl || '/img/avt_placeholder.jpg'"
            :s3FolderPath="s3StudentsAvatarPath"
            @on-upload-s3-success="onUploadS3Success"
          />
        </div>
        <div class="md-layout-item hidden md:block"></div>
      </div>
      <div class="md-layout mt-4">
        <student-information-tabs
          ref="infoRef"
          :path="path"
          @update-check-footer="hasFooterActions = $event"
          :action-footer="hasFooterActions"
        ></student-information-tabs>
      </div>

      <footer class="flex justify-center" v-if="hasFooterActions && canEdit">
        <md-button @click="goToStudentPage"
          >{{ $t("common.cancel") }}
        </md-button>

        <md-button class="md-success ml-4" type="submit"
          >{{ $t("common.update") }}
        </md-button>
      </footer>
    </div>
  </validation-form>
</template>

<script>
import { getId, Message } from "@/helpers/utils";
import { service_paths } from "@/constants/Services";
import AWSConst from "@/constants/AWS";
import Avatar from "@/components/Base/Avatar";
import IsisFab from "@/components/Base/IsisFab";
import StudentInformationTabs from "./Tabs";
import ChangePassword from "@/pages/ChangePassword";
import FixedNoteList from "@/pages/FixedNoteList.vue";
import { mapGetters, mapState } from "vuex";
import {
  chat_room_names,
  forbidden_router_name,
  student_router_names
} from "@/routes/routes";
import { hasValidRole, isDynamicRole } from "@/helpers/role-helper";
import Role from "@/constants/Role";
import { Class, Student } from "@/constants/Permissions";
import ButtonChangePassword from "@/components/Base/ButtonChangePassword.vue";

export default {
  components: {
    Avatar,
    StudentInformationTabs,
    IsisFab,
    FixedNoteList,
    ChangePassword,
    ButtonChangePassword
  },
  data() {
    return {
      path: service_paths.students,
      hasFooterActions: true,
      studentData: {},
      familyData: {},
      s3StudentsAvatarPath: `${AWSConst.S3_STUDENTS_UPLOAD_PATH}/avatars`,
      changePasswordModal: {
        name: "change-password",
        title: "student.change_password"
      },
      hasValidRole,
      Role,
      Student,
      isDynamicRole
    };
  },
  computed: {
    ...mapState("user", ["info"]),
    ...mapGetters("user", ["role"]),
    // ...mapGetters("chat", { isModeSupporter: "isModeSupporterLocal" }),

    verifyUser() {
      return (
        getId(this.info) === this.studentId ||
        hasValidRole(this.role, [Role.Counselor, Role.Teacher]) ||
        this.$can(Student.actions.edit, Student.subject) ||
        this.$can(Student.actions.view, Student.subject) ||
        this.$can(Class.actions.view, Class.subject) ||
        this.$can(Class.actions.edit, Class.subject)
      );
    },

    canEdit() {
      return this.$can(Student.actions.edit, Student.subject);
    },

    uuid() {
      return this.studentData.uuid || "";
    },

    avatarUrl() {
      return this.studentData && this.studentData.avatar_url;
    },

    studentId() {
      return this.$route.params.id;
    }
  },
  created() {
    this.getStudentData();
    if (!this.verifyUser) {
      this.$router.push({ name: forbidden_router_name });
    }
  },
  methods: {
    async connectChat() {
      const userId = this.$route.params.id;
      let { data } = await this.$axios.post(
        `${service_paths.chat}/direct/users/${userId}`
      );
      const roomIdUser = getId(data);
      const route = this.$router.resolve({
        name: chat_room_names.listPage,
        query: { direct_id: roomIdUser }
      });
      window.open(route.href, "_blank");
    },
    goToStudentPage() {
      this.$router.push({ name: student_router_names.listPage });
    },
    updateAccount() {
      this.$refs.infoRef.updateAccount();
    },
    updateStudentData(formData) {
      const errMsg = this.$t("common.form_invalid");
      return this.$axios
        .put(`${this.path}/${this.studentId}`, formData, true, {}, errMsg)
        .then(({ data }) => {
          Message.success(this.$t("student.update_student_success"));
          this.$refs.infoRef.setFormData(data);
          return data;
        })
        .catch(error => {
          throw error;
        });
    },

    onUploadS3Success(savedLink) {
      const data = {
        avatar_url: savedLink
      };

      this.$axios.put(`${this.path}/${this.studentId}`, data).then(() => {
        Message.success(this.$t("student.update_avatar_successfully"));
      });
    },

    getStudentData() {
      return this.$axios
        .get(`${this.path}/${this.studentId}`)
        .then(({ data }) => {
          this.studentData = data;
          this.$refs.infoRef.setFormData(data);
        });
    },
    showChangePasswordModal() {
      this.$modal.show(this.changePasswordModal.name);
    }
  },
  provide() {
    return {
      fetchStudentData: this.getStudentData,
      updateStudentData: this.updateStudentData
    };
  }
};
</script>

<style lang="scss" scoped>
.btn-close-iframe {
  height: 42px;
  width: 42px;
  background: grey;
  top: -23px;
  left: -23px;
  position: absolute;
  border-radius: 100px;
  color: white;
}
</style>
